//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from '@/components/autoscale/loader';
import PageLayout from '@/components/autoscale/pageLayout';
import TopSection from './components/top';
import AdditionalSection from './components/additional/index.vue';
import SpeakersSection from './components/speakers.vue';
import ScheduleSection from './components/schedule.vue';
import RecommendationsSection from './components/recommendations.vue';

import createHead from './-head';
import getCookie from '@/utils/getCookie';
import saveAndSendMetadataMixin from '@/mixins/saveAndSendMetadata.mixin';

export default {
  name: 'Event',
  components: {
    Loader,
    PageLayout,
    TopSection,
    AdditionalSection,
    SpeakersSection,
    ScheduleSection,
    RecommendationsSection,
  },
  mixins: [saveAndSendMetadataMixin],
  layout: 'scaled',
  data() {
    return {
      timer: null,
      subscriptionChecked: false,
    };
  },
  async fetch() {
    await this.getEvent();

    // Ивент не найден
    if (!this.event?.id) {
      this.$nuxt.error({ statusCode: 404 });
    }

    this.forceStatuses();
  },
  head() {
    const createHeadFunction = createHead.bind(this);
    return createHeadFunction();
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    buzy: {
      get() {
        return this.$store.state.event.buzy;
      },
      set(payload) {
        this.$store.commit('event/SET_BUZY', payload);
      },
    },

    // Данные ивента и топика нужны для createHeadFunction
    event() {
      return this.$store.state.event?.data;
    },
    activeTopic() {
      return this.event?.activeTopic;
    },

    // Если открыт полноэкранный просмотр видео\чата - скрыть хедер
    displayMobileView() {
      return this.$store.state.event.displayMobileView;
    },

    // Данные для force статусов
    topicsStatuses() {
      return this.$store.state.event.topicsStatuses;
    },
    eventStatus() {
      return this.$store.state.event.eventStatus;
    },
    closeRegistration() {
      return this.$store.state.event.closeRegistration;
    },
    isRecomendationsBlockVisible() {
      return this.$app.config.common.currentCountry !== 'co';
    }
  },
  watch: {
    event: {
      async handler() {
        if (process.client) {
          await this.$nextTick();

          this.setTimer();
          this.checkSubscription();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.subscribeOnStore();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    /** Получить данные ивента из CMS */
    async getEvent() {
      await this.$store.dispatch('event/GET_EVENT_DATA', this.slug);
    },

    /** Проверить, подписан ли юзер на ивент */
    checkSubscription() {
      if (this.subscriptionChecked) return;

      const slug = this.$route.params.slug;
      this.subscriptionChecked = true;

      // https://ebaconline.atlassian.net/browse/FT-1666
      // Нужно проверить, что у нас не только есть a_token
      // но и сам юзер авторизован
      // Так как бывают ситуации, когда токен просрочен, но isMine всё равно вызывается
      if (!this.$app.user) return;

      const a_token = getCookie({ name: 'a_token', cookies: document.cookie });
      this.$store.dispatch('event/GET_SUBSCRIPTION', { a_token, slug });
    },
    /** Таймер, отслеживающий изменение статуса активного топика */
    setTimer() {
      if (!this.activeTopic) return;

      const diffTopicLive = this.$store.state.event.diffTopicLive;
      const diffTopicFinished = this.$store.state.event.diffTopicFinished;
      const diffEventEnded = this.$store.state.event.diffEventEnded;

      const now = this.$dayjs.utc();

      const startDate = this.$dayjs(this.activeTopic.topicDateUtc);
      const diffTime = startDate.diff(now);

      // Таймер определяет, когда топик переключится в режим live или finished
      if (diffTime < diffTopicLive) {
        // Отправить событие присутствия на ивенет
        this.saveAndSendMetadata({
          clearTimerTime: diffTime + diffTopicFinished,
          selectedTopic: this.activeTopic,
        });

        this.$store.dispatch('event/UPDATE_TOPICS_STATUSES');
      } else {
        // Если до старта больше десяти минут -
        // ждём время до старта и снова запускаем проверку
        this.timer = setTimeout(this.setTimer, diffTime - diffTopicLive);
        return;
      }

      // Если со старта топика прошло 2 часа - отмечаем его как finished
      if (diffTime < -diffTopicFinished) {
        this.$store.dispatch('event/UPDATE_TOPICS_STATUSES');
      } else {
        // Если до старта меньше десяти минут, но два часа со старта ещё не прошло
        // ждём время и снова запускаем проверку
        this.timer = setTimeout(this.setTimer, diffTime + diffTopicFinished);
        return;
      }

      // Если последний топик завершился - ивент считается завершённым через 30 часов
      // после окончания последнего ивента
      if (diffTime < -diffEventEnded) {
        this.$store.dispatch('event/UPDATE_TOPICS_STATUSES');
      } else {
        this.timer = setTimeout(this.setTimer, diffTime + diffEventEnded);
        return;
      }
    },
    /** Ручное изменение статусов через адрес страницы */
    forceStatuses() {
      if (!this.activeTopic) return;

      const forceLive =
        this.$route.query.forceLive === 'true' ||
        this.$route.query.forcelive === 'true';

      const forceFinished =
        this.$route.query.forceFinished === 'true' ||
        this.$route.query.forcefinished === 'true';

      const num = this.activeTopic.num;

      if (forceLive) {
        this.$store.dispatch('event/UPDATE_TOPIC_STATUS', {
          num,
          status: 'live',
        });
        console.info('%c FORCE STATUSES ENABLED', 'color: red', {
          topicsStatuses: this.topicsStatuses,
          eventStautus: this.eventStatus,
          closeRegistration: this.closeRegistration,
        });
      }

      if (forceFinished) {
        this.$store.dispatch('event/UPDATE_TOPIC_STATUS', {
          num,
          status: 'finished',
        });
        this.$nextTick(() => {
          console.info('%c FORCE STATUSES ENABLED', 'color: red', {
            topicsStatuses: this.topicsStatuses,
            eventStautus: this.eventStatus,
            closeRegistration: this.closeRegistration,
          });
        });
      }
    },

    // Автовебинары
    subscribeOnStore() {
      this.$store.subscribe((...args) => {
        this.subscribeOnStoreForAutoWebinars(...args);
      });
    },
    subscribeOnStoreForAutoWebinars(mutation) {
      if (
        mutation.type === 'event/SET_IS_SUBSCRIBED' ||
        mutation.type === 'event/UPDATE_TOPIC_STATUS_BY_NUM'
      ) {
        this.$store.dispatch(
          'event/SET_AUTO_WEBINARS_ALLOW_REDIRECT_BY_CONDITION',
        );
      }
    },
  },
};
